var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.067,
    height: 21.067,
    viewBox: "0 0 21.067 21.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61532",
    "data-name": "Group 61532",
    transform: "translate(-1445.479 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61531",
    "data-name": "Group 61531",
    transform: "translate(1442.229 426.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221553",
    "data-name": "Path 221553",
    d: "M12.127,18.033a.9.9,0,0,0,1.276,0l3.612-3.612a.9.9,0,0,0-1.277-1.277l-2.071,2.071V4.153a.9.9,0,0,0-1.806,0V15.215L9.79,13.144a.9.9,0,0,0-1.277,1.277l3.612,3.612Z",
    transform: "translate(1.019 0)",
    fill: "#1b7ea0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221554",
    "data-name": "Path 221554",
    d: "M23.414,14.25a.9.9,0,0,0-.9.9v3.612a1.507,1.507,0,0,1-1.5,1.5H6.561a1.507,1.507,0,0,1-1.5-1.5V15.153a.9.9,0,1,0-1.806,0v3.612a3.313,3.313,0,0,0,3.311,3.311H21.007a3.313,3.313,0,0,0,3.311-3.311V15.153A.9.9,0,0,0,23.414,14.25Z",
    transform: "translate(0 2.242)",
    fill: "#1b7ea0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/download_button.f36764e59a065f728a295bd5ae4a8a4b.svg";
export { ForwardRef as ReactComponent };